export default __webpack_public_path__ + "static/media/featuresArticle.5a967a08.svg";